import Cookies from 'js-cookie'

const Ticker = function () {

  function init() {
    const tickerElement = document.getElementById('ticker')

    if (!tickerElement) return

    const tickerCounter = tickerElement.dataset.tickerCounter
    const tickerLang = tickerElement.dataset.tickerLang
    const tickerCookie = Cookies.get(`hide-news-ticker-${tickerLang}`)

    let showTicker = true

    if (typeof tickerCookie === 'string') {
      showTicker = Number(tickerCookie) < Number(tickerCounter)
    }

    if (tickerElement && showTicker) {
      tickerElement.hidden = false
    }

    tickerElement.querySelector('button').addEventListener('click', () => {
      tickerElement.hidden = true
      Cookies.set(`hide-news-ticker-${tickerLang}`, tickerCounter, {
        expires: 30
      })
    })
  }

  return {
    init
  }

}()

export default Ticker
